import { CONCEPT_STICKERS } from "./heroStickers";
import { buildTagStickers, StickerDef } from "./StickerDesigns";
import { classifyTag } from "./stickerClassifier";

// Which of a clip's tags are "sticker-eligible". This is the single seam between
// the clip's tags and the sticker tray — Phase 2 swaps the `universe` source
// from the hardcoded backend tag-options list to the admin-published sticker
// catalog without touching the editor.
//
//  - universe is an array (EVEN EMPTY): authoritative — strict intersection.
//    An empty list means the scope is curated to zero, so we show no tag
//    stickers (don't second-guess the admin).
//  - universe is null/undefined (endpoint unreachable / scope unknown): safer
//    than "show everything" — keep a tag only if it has a hand-tuned hero design
//    or classifies into a real trick family (not Generic). Keeps freeform / typo
//    / location tags out of the tray.
export function filterEligibleTags(
    tags: string[],
    universe: string[] | null | undefined,
): string[] {
    if (universe != null) {
        const lowerSet = new Set(universe.map((t) => t.toLowerCase()));
        return tags.filter((t) => lowerSet.has(t.toLowerCase()));
    }
    return tags.filter((t) => {
        const key = t.trim().toLowerCase();
        if (CONCEPT_STICKERS[key]) return true;
        return classifyTag(t) !== "Generic";
    });
}

// Build the tag tray: up to `variantsPerTag` sticker variants per eligible tag,
// flattened, preserving the tags' given order.
export function buildTagTray(eligibleTags: string[], variantsPerTag: number): StickerDef[] {
    return eligibleTags.flatMap((t) =>
        buildTagStickers(t, classifyTag(t)).slice(0, variantsPerTag),
    );
}
